module.exports = __webpack_public_path__ + "img/荣誉证书08_软件产品证书.5fb8116a.png";